import {Component, OnInit} from '@angular/core';
import {ShopBaseComponent} from "../shop-base.component";

@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html',
})
export class CheckoutComponent extends ShopBaseComponent implements OnInit {
    tabNumber: number = 0;
    products: any[] = [];
    shipmentPrice?: number;

    isTabsEnabled: boolean = false;

    ngOnInit() {
        this.products = this.getProductsLocalStorage();
    }

    async setTabNumber(index: number) {
        this.tabNumber = index;
    }
    changeTabNumber() {
        this.isTabsEnabled = true;
        this.tabNumber += 1;
    }

    onShippingPriceChange(shippingPrice: number) {
        this.shipmentPrice = shippingPrice;
    }

    lastPrice(products: any) {
        return this.cartSubTotal(products) + parseFloat(String(this.shipmentPrice || 0));
    }
}
